import request from '../utils/request';

export default postalOperatorCode => request(`/mdm/mail-processing-centers-codes/postal-operator/${postalOperatorCode}`);
